import { makeStyles } from '@material-ui/core/styles';

const arrowDownStyles = makeStyles(() => ({
  iconMore: {
    fontWeight: 'light ! important',
    marginRight: '5px',
    color: 'black',
    width: '0.9em',
  },
}));
// eslint-disable-next-line import/prefer-default-export
export { arrowDownStyles };
